import React from "react";
import TopNavbar from "../components/commonComponents/Navbar/Navbar";
import VideosBlog from "../components/videoBlog/index";
import Footer from "../components/commonComponents/footer";
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";

export default function VideoBlog() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {pageLoader &&
                <PageLoader />
            }
            <TopNavbar />
            <VideosBlog />
            <Footer />
        </div>
    )
}